import React from 'react';
import { Chip } from '../../lib/types';
import { useToast } from '../../components/Toast/ToastContext';
import Modal, { ModalTitle, ModalSubtitle, ModalActions } from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';

interface RecallModalProps {
  open: boolean;
  onClose: () => void;
  chip: Chip | null;
  onRecall: (chipId: string) => void;
}

export default function RecallModal({ open, onClose, chip, onRecall }: RecallModalProps) {
  const { showToast } = useToast();

  if (!chip) return null;

  function handleConfirm() {
    onRecall(chip!.id);
    showToast(`Owner cleared from ${chip!.id}`);
    onClose();
  }

  return (
    <Modal open={open} onClose={onClose}>
      <ModalTitle>Clear owner</ModalTitle>
      <ModalSubtitle>
        Are you sure you want to clear the owner from chip <strong>{chip.id}</strong>
        {chip.petName ? ` (${chip.petName})` : ''}? Pet information will be preserved.
      </ModalSubtitle>
      <ModalActions>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          Clear
        </Button>
      </ModalActions>
    </Modal>
  );
}
